<template>
    <v-container grid-list-md fluid>
        <v-layout warp>
            <CompaniesTable v-bind:editable="true" v-bind:showParentCompany="true" />
        </v-layout>
    </v-container>
</template>
<script lang="ts">
import CompaniesTable from "./CompaniesTable.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
    },
})
export class Companies extends Vue {}

export default toNative(Companies);
</script>
